import React from 'react';
import styles from './Sidebar.module.css';
import {
	CHECKS_ICON,
	CLOSE_ICON,
	LOGIN_ROUTE,
	LOGOUT_ICON,
	PROJECTS_ICON,
	PROJECTS_ROUTE,
	SETTINGS_ICON,
	SETTINGS_ROUTE,
	USERS_ICON,
	USERS_ROUTE,
	WEB_CHECKS_ROUTE,
} from '../../utils/consts';
import { Button, LinkIcon, SidebarLink } from '../../components';

const Sidebar = () => {
	const is_admin = true;

	return (
		<aside
			className='offcanvas-lg offcanvas-start col-lg-3 col-xl-2 px-0 min-vh-100'
			tabIndex='-1'
			id='offcanvasResponsive'>
			<div
				className={`background-secondary border-tertiary h-100 ${styles.borderTopBottomNone}`}>
				<div className='offcanvas-header background-secondary'>
					<h5 className='offcanvas-title'>Sidebar</h5>
					<Button
						icon={CLOSE_ICON}
						classes={'px-0 color-header'}
						data-bs-dismiss='offcanvas'
						data-bs-target='#offcanvasResponsive'></Button>
				</div>
				<div className='position-sticky top-0 h-75'>
					<div className='offcanvas-body h-100'>
						<nav
							className={`d-flex flex-column justify-content-between w-100 vh-90 ${styles.bodyHeight}`}>
							<ul className='nav nav-pills flex-column px-3 pt-3 gap-2 w-100 mt-4'>
								<SidebarLink
									route={PROJECTS_ROUTE}
									icon={PROJECTS_ICON}
									label={'Projekte'}
								/>
								{is_admin && (
									<>
										<SidebarLink
											route={USERS_ROUTE}
											icon={USERS_ICON}
											label={'Benutzer'}
										/>
										<SidebarLink
											route={WEB_CHECKS_ROUTE}
											icon={CHECKS_ICON}
											label={'Web Checks'}
										/>
									</>
								)}
							</ul>
							<div
								className={`d-flex justify-content-center gap-4 mb-4 ${styles.dividerTop} mx-4`}>
								<LinkIcon
									route={SETTINGS_ROUTE}
									icon={SETTINGS_ICON}
									classes={'background-tertiary'}
								/>
								<LinkIcon
									route={LOGIN_ROUTE}
									icon={LOGOUT_ICON}
									classes={'background-tertiary color-red'}
								/>
							</div>
						</nav>
					</div>
				</div>
			</div>
		</aside>
	);
};

export default Sidebar;
